import { FC } from 'react';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';
import { useFaqItem, Props } from './useFaqItem';
import styles from './FaqItem.module.css';

export const FaqItem: FC<Props> = (props) => {
  const { title, isOpen, children, onClickHeader } = useFaqItem(props);

  return (
    <div className={styles.faq}>
      <button className={styles.header} onClick={onClickHeader}>
        <div className={styles.title}>{title}</div>
        {isOpen &&
        <div>
            <FontAwesomeIcon icon={faMinus} />
          </div>}

        {!isOpen &&
        <div>
            <FontAwesomeIcon icon={faPlus} />
          </div>}

      </button>
      <div className={clsx(styles.body, isOpen && styles.openBody)}>
        {children}
      </div>
    </div>);

};